/* pantallas-alumno (B): LA CUADRICULA DE SALTO DEL EXAMEN (piezas nuevas de la parte 1 y P12).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Botones de 38 (44 en la hoja), radio 10, 13 px seminegrita. Actual: fondo #F27A2E, texto #160A02.
   Contestada: fondo #262626, borde #3A3A3A, texto #F4F4F3. Sin contestar: fondo #141414, borde
   #2C2C2C, texto #9A9A9A. Leyenda opcional de 12.5 px #9A9A9A con cuadritos de 14.

   P12 (`desplazarALaActual`): al abrir y al cambiar de pregunta, la cuadricula se desplaza sola hasta
   la actual ("nearest": lo justo para que se vea). Con "reducir movimiento" el salto es inmediato. Sin
   la opcion no se mueve nada.
   smoke-alumno (S4, orden de Carlos del 20-oct): ya no con `scrollIntoView`, que movia TODAS las cajas
   que la contienen, el documento incluido (en el iPhone, con el cuerpo bloqueado por la hoja, la
   pantalla quedaba corrida al cerrarla y ya no se podia subir). Se mueve SOLO la caja de los botones
   (`desplazarDentroDeLaCaja`, la misma de la cuadricula fija; la caja lleva posicion relativa).

   `actual` y `onSaltar` usan el INDICE (0, 1, 2...); el numero pintado es indice + 1. `contestadas`
   es un arreglo de verdaderos por indice. Esta pieza no decide nada: solo pinta y avisa el toque. */
import React, { useEffect, useRef } from 'react';
import { reducirMovimiento } from '../panel/useReacomodo';
import { desplazarDentroDeLaCaja } from '../../lib/desplazarALaActual';

const BASE = 'shrink-0 rounded-[10px] border text-[13px] font-semibold tabular-nums flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white active:brightness-90';
const TAMANO = { normal: 'w-[38px] h-[38px]', hoja: 'w-11 h-11' };
const ESTADO = {
  actual: 'bg-[#F27A2E] border-[#F27A2E] text-[#160A02]',
  contestada: 'bg-[#262626] border-[#3A3A3A] text-[#F4F4F3]',
  sin_contestar: 'bg-[#141414] border-[#2C2C2C] text-[#9A9A9A]',
};
const CUADRITO = {
  actual: 'bg-[#F27A2E] border-[#F27A2E]',
  contestada: 'bg-[#262626] border-[#3A3A3A]',
  sin_contestar: 'bg-[#141414] border-[#2C2C2C]',
};

export default function CuadriculaDeSalto({
  total = 0, actual = 0, contestadas = [], onSaltar, enHoja = false, desplazarALaActual = false, leyenda,
  etiquetaDe, testid, className = 'flex flex-wrap gap-2',
}) {
  const actualRef = useRef(null);
  useEffect(() => {
    if (!desplazarALaActual) return;
    const b = actualRef.current;
    if (!b) return;
    desplazarDentroDeLaCaja(b.parentElement, b, !reducirMovimiento());
  }, [actual, desplazarALaActual]);

  const tamano = enHoja ? TAMANO.hoja : TAMANO.normal;
  const botones = [];
  for (let i = 0; i < total; i += 1) {
    const estado = i === actual ? 'actual' : (contestadas && contestadas[i] ? 'contestada' : 'sin_contestar');
    botones.push(
      <button
        key={i}
        ref={i === actual ? actualRef : undefined}
        type="button"
        aria-current={i === actual ? 'step' : undefined}
        aria-label={etiquetaDe ? etiquetaDe(i, estado) : undefined}
        data-estado={estado}
        data-testid={testid ? `${testid}-${i}` : undefined}
        onClick={() => { if (onSaltar) onSaltar(i); }}
        className={`${BASE} ${tamano} ${ESTADO[estado]}`}
      >
        {i + 1}
      </button>,
    );
  }
  return (
    <div>
      <div data-testid={testid} className={className}>{botones}</div>
      {leyenda ? (
        <div data-testid={testid ? `${testid}-leyenda` : undefined} className="mt-2.5 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[12.5px] text-[#9A9A9A]">
          {[['actual', leyenda.actual], ['contestada', leyenda.contestada], ['sin_contestar', leyenda.sinContestar]].map(([k, txt]) => (
            <span key={k} className="inline-flex items-center gap-1.5">
              <span data-parte="cuadrito" aria-hidden="true" className={`w-3.5 h-3.5 rounded-[4px] border ${CUADRITO[k]}`} />
              {txt}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
}
